// extracted by mini-css-extract-plugin
module.exports = {"resultsDropdown":"_8693bb0"};